
import React, { useState, useRef, useEffect } from 'react';
import AccordionItem from './AccordionItem';

interface AccordionProps {
  items: {
    title: string | JSX.Element;
    content: string | JSX.Element;
  }[];
}

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [openIndices, setOpenIndices] = useState<number[]>([]);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]); 

  const handleClick = (index: number) => {
    setOpenIndices(prevOpenIndices =>
      prevOpenIndices.includes(index)
        ? prevOpenIndices.filter(i => i !== index)
        : [...prevOpenIndices, index]
    );
  };

  useEffect(() => {
    if (openIndices.length > 0) {
      const lastOpenedIndex = openIndices[openIndices.length - 1];
      itemRefs.current[lastOpenedIndex]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [openIndices]);

  return (
    <div className="rounded-xl bg-background">
      {items.map((item, index) => (
        <div
          key={index}
          ref={el => (itemRefs.current[index] = el)} 
          className="accordion-item"
        >
          <AccordionItem
            title={<span className="text-sm">{item.title}</span>}
            isOpen={openIndices.includes(index)}
            onClick={() => handleClick(index)}
          >
            {item.content}
          </AccordionItem>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
